export default {
  localhost: {
    url: process.env.VUE_APP_URL_API_LOCAL,
  },
  server: {
    url: process.env.VUE_APP_URL_API_SERVER,
  },

}